module.exports = __webpack_public_path__ + "static/media/marker_icon_elkhorn.32401bf4.svg";